import { themedUseStyletron } from '../../../theme/customTheme'
// icons
import { OperatorPanelWrapper, OperatorPanelWrapperFullSize } from '../../components/Layout'
import { OverviewPanel as BacnetDeviceView } from '../BacnetDevice/BacnetDevicesView'
import { IEdgeDevice } from './types';


export const OperatorPanel = (props: IEdgeDevice) => {
  const [, theme] = themedUseStyletron();


  return (
    <>
    
    <OperatorPanelWrapperFullSize
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={
        <>
          <BacnetDeviceView parentId={props.id} parentResouceGroupId={props.resourceGroupId} />
        </>
      }
      operationModeContent={
        <></>
      }
    >
    </OperatorPanelWrapperFullSize>

    </>
  )
} 